import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { decodeData } from '../../../utils/encodeAndEncode';
import { getCourseModule } from '../../../services/organization/courses/courseContent.service';

export function useCourseName() {
  const { courseId } = useParams();
  const location = useLocation();
  const passedName = location.state?.courseName || '';
  const [loadedName, setLoadedName] = useState('');

  useEffect(() => {
    if (passedName || !courseId) return undefined;

    let active = true;
    const decodedCourseId = decodeData(courseId);
    if (!decodedCourseId) return undefined;
    setLoadedName('');

    getCourseModule({ id: decodedCourseId, search: '' })
      .then((response) => {
        if (active && response?.success) setLoadedName(response.data?.course_name || '');
      })
      .catch(() => {
        if (active) setLoadedName('');
      });

    return () => { active = false; };
  }, [courseId, passedName]);

  return passedName || loadedName;
}

export default function CourseNameHeading({ name }) {
  if (!name) return null;

  return (
    <div className="tw-mb-5 tw-flex tw-flex-wrap tw-items-baseline tw-gap-x-2 tw-gap-y-1">
      <span className="tw-text-sm tw-font-medium tw-text-slate-500">Course Name:</span>
      <span className="tw-break-words tw-text-base tw-font-semibold tw-text-slate-700">{name}</span>
    </div>
  );
}
